import { useState } from 'react';
import { ROUTE_LOGIN } from '../../../config/routes';
import { getActionType, POSTHOG_CAPTURE_ATTRIBUTES, TRACKER_IDS } from '../../../config/tracker';
import { isTrashieApp, trashieRoute } from '../../../../../config/config';
import { getSleekOfferAffiliateUrl } from '../../../utils/service';
import LinkIcon from '../../../images/square-arrow-out-up-right.svg';
import TCCoinSvg from '../../../global/SvgComponents/TCCoin_svg';
import { formatDecimalNumber } from '../../../utils/numbers';

import './OfferItemV2.scss';

const {
  offers: {
    offerItem: trackerOfferItem,
  },
} = TRACKER_IDS;

const OfferItem = ({
  offerItem: {
    offerId,
    retailerId,
    name,
    cashbackAmount,
    logoUrl,
    url,
    config,
  },
  isDashBoard,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = async (e) => {
    e.preventDefault();

    if (isLoading) return;

    setIsLoading(true);

    try {
      if (isDashBoard) {
        const { data, error } = await getSleekOfferAffiliateUrl(offerId);

        if (error) {
          console.error('Error fetching affiliate URL:', error);
        } else {
          const affiliateUrl = data?.affiliateUrl || url;
          window.open(affiliateUrl, '_blank', 'noopener,noreferrer');
        }
      } else {
        const redirectUrl = `${!isTrashieApp() ? trashieRoute() : ''}${ROUTE_LOGIN}?uri=${url}`;
        window.location.href = redirectUrl;
      }
    } catch (error) {
      console.error('Error in handleClick:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      handleClick(e);
    }
  };

  return (
    <div
      className="OfferItemV2"
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
      style={{ cursor: isLoading ? 'wait' : 'pointer' }}
      {...{
        [POSTHOG_CAPTURE_ATTRIBUTES.ACTION_ID]: getActionType(trackerOfferItem),
        [POSTHOG_CAPTURE_ATTRIBUTES.OFFER_ID]: offerId,
        [POSTHOG_CAPTURE_ATTRIBUTES.OFFER_MERCHANT_ID]: retailerId,
        [POSTHOG_CAPTURE_ATTRIBUTES.OFFER_MERCHANT_NAME]: name,
      }}
    >
      <div className="OfferItemV2__logoContainer">
        <div className="OfferItemV2__logoContainer--linkArrow">
          <img src={LinkIcon} alt="link-arrow" />
        </div>
        <div
          className="OfferItemV2__logoContainer--imgContainer"
          style={{
            backgroundColor: config?.backGround,
          }}
        >
          <img
            src={logoUrl}
            alt="offer-logo"
          />
        </div>
      </div>
      <div className="OfferItemV2__details">
        <div className="OfferItemV2__details--activateButton">
          <TCCoinSvg width={14} height={14} />
          {`Up to ${formatDecimalNumber(cashbackAmount * 100)}%`}
        </div>
      </div>
    </div>
  );
};

export default OfferItem;
